<template>
  <main-layout :selectedMenu="'home'">
    <section class="dateforum2019">
      <div class="bg"></div>
      <div class="container">
        <div class="banner">
          <img :src="`assets/pc/cn/event/v2/Banner_temp.png` | imageUrl('','','',true)" alt />
        </div>
        <div class="nav" :class="{topPosition:flag}">
          <el-menu mode="horizontal">
            <el-menu-item v-for="(item,idx) in list" :index="item.title" :key="item.id">
              <a v-if="item.id" @click.prevent="navTo(idx)">{{item.title}}</a>
              <a :href="`${item.href}`" v-if="item.href" :download="$t('global.日程表')">{{item.title}}</a>
            </el-menu-item>
            <el-menu-item index="0" class="buy">
              <a @click.prevent="navTo(1)">{{$t('global.预售票购买')}}</a>
            </el-menu-item>
          </el-menu>
        </div>
        <div class="content">
          <ul>
            <li v-for="(item,idx) in list" :key="item.id" :id="item.id">
              <div class="buy-warp" v-if="item.id==='08.30'">
                <img :src="`assets/pc/cn/event/v2/${item.id}.png` | imageUrl('','','',true)" alt />
                <a v-for="it in [1,2,3]" :href="url[`${item.id}_${it}`]" target="_blank" :key="it">
                  <img :src="`assets/pc/cn/event/v2/web_buy_ticket_btn.png` | imageUrl('','','',true)" alt />
                </a>
              </div>
              <div class="buy-warp" v-if="item.id==='08.31'">
                <img :src="`assets/pc/cn/event/v2/${item.id}.png`| imageUrl('','','',true)" alt />
                <a v-for="it in [1,2,3]" :href="url[`${item.id}_${it}`]" target="_blank" :key="it">
                  <img :src="`assets/pc/cn/event/v2/web_buy_ticket_btn.png`| imageUrl('','','',true)" alt />
                </a>
              </div>
              <div class="buy-warp" v-if="item.id==='09.01'">
                <img :src="`assets/pc/cn/event/v2/${item.id}.png`| imageUrl('','','',true)" alt />
                <a
                  v-for="it in [1,2,3,4]"
                  :href="url[`${item.id}_${it}`]"
                  target="_blank"
                  :key="it"
                >
                  <img :src="`assets/pc/cn/event/v2/web_buy_ticket_btn.png`| imageUrl('','','',true)" alt />
                </a>
              </div>
              <img
                :src="`assets/pc/cn/event/v2/${item.id}.png`| imageUrl('','','',true)"
                alt
                v-if="item.id!=='08.30'&&item.id!=='08.31'&&item.id!=='09.01'"
              />
              <a :href="url.detail" class="detail" v-if="idx===0"></a>
              <img :src="`assets/pc/cn/event/v2/richeng.png`| imageUrl('','','',true)" alt v-if="idx=== 0" />
              <img
                :src="`assets/pc/cn/event/v2/zhubanfangjianjie.png`| imageUrl('','','',true)"
                alt
                v-if="idx=== 4"
              />
            </li>
          </ul>
        </div>
      </div>
    </section>
  </main-layout>
</template>

<script>
import "./style/dateforum2019.css";
import MainLayout from "@/layouts/MainLayout";
export default {
  metaInfo() {
    return {
      title: this.$t("global.上海设计周先锋论坛") + " | MANA"
    };
  },
  data() {
    return {
      list: [
        {
          id: "jieshao",
          title: this.$t('global.论坛介绍')
        },
        {
          id: "08.30",
          title: "08.30"
        },
        {
          id: "08.31",
          title: "08.31"
        },
        {
          id: "09.01",
          title: "09.01"
        },
        {
          id: "wangjiejiabing",
          title: this.$t('global.本届嘉宾')
        },
        {
          id: "shangwuhezuo",
          title: this.$t('global.商务合作')
        }
        // ,{
        //   title: $t('global.日程表下载'),
        //   href: "xxx"
        // }
      ],
      flag: false,
      liHeight: [0],
      url: {
        "08.30_1": "https://www.huodongxing.com/event/8497028461400",
        "08.30_2": "https://www.huodongxing.com/event/9497016199500",
        "08.30_3": "https://www.huodongxing.com/event/1497017432700",
        "08.31_1": "https://www.huodongxing.com/event/2497012689200",
        "08.31_2": "https://www.huodongxing.com/event/4497019975500",
        "08.31_3": "https://www.huodongxing.com/event/2497015073500",
        "09.01_1": "https://www.huodongxing.com/event/5497017831000",
        "09.01_2": "https://www.huodongxing.com/event/9497016618900",
        "09.01_3": "https://www.huodongxing.com/event/3497020378800",
        "09.01_4": "https://www.huodongxing.com/event/3497020378800",
        detail: "http://www.designweek.sh.cn/index.php/home"
      }
    };
  },
  components: {
    MainLayout
  },
  methods: {
    navTo(idx) {
      setTimeout(() => {
        document.querySelector("html").scrollTop = this.liHeight[idx];
        document.body.scrollTop = this.liHeight[idx];
      }, 100);
    },
    getAllHeightList() {
      // const contentList = document.querySelectorAll(".content li");
      // const height = document.querySelector(".banner").offsetHeight;
      // [...contentList].forEach((item, index) => {
      //   this.liHeight[index + 1] =
      //     (this.liHeight[index] || height) + item.offsetHeight;
      // });
      // console.log(this.liHeight);
      this.liHeight = [0, 2080, 2660, 3240, 4128, 10350];
    },
    scroll() {
      document.querySelector(".nav .el-menu-item").classList.add("is-active");
      document.addEventListener("scroll", e => {
        const scrollTop =
          document.querySelector("html").scrollTop || document.body.scrollTop;
        const height = document.querySelector(".banner").offsetHeight;
        if (scrollTop > height + 60) {
          this.flag = true;
        } else {
          this.flag = false;
        }
        this.liHeight.forEach((item, index) => {
          if (
            scrollTop >= item &&
            (scrollTop < this.liHeight[index + 1] || !this.liHeight[index + 1])
          ) {
            document
              .querySelectorAll(".nav .el-menu-item")
              [index].classList.add("is-active");
          } else {
            document
              .querySelectorAll(".nav .el-menu-item")
              [index].classList.remove("is-active");
            document.querySelectorAll(".nav .el-menu-item")[index].blur();
          }
        });
      });
    }
  },
  mounted() {
    setTimeout(() => {
      this.getAllHeightList();
      this.scroll();
    }, 1000);
  }
};
</script>




// WEBPACK FOOTER //
// src/pages/event/Dateforum2019.vue